<template>
  <div :class="['ep-tag',{'ep-tag-border':border}]">
    <div class="ep-tag-con" :style="{'left':groupLeft+'px'}">
      <slot></slot>
    </div>
  </div>
</template>

<script>
  import unit from '../../../lib/unit'
  export default {
    name: 'ep-tag',
    props: {
      value: {
        default: ''
      },
      border: {
        default: false
      }
    },
    data() {
      return {
        groupLeft: 0
      }
    },
    created() {
      this.$on('change', (val, curTarget) => {
        this.broadcast('ep-tag-list', 'change', val)
        this.controll_move(curTarget)
      })
    },
    methods: {
      // 控制位移
      controll_move(curTarget) {
        // 位移计算
        let curDom = curTarget.target
        let parentDom = curDom.parentNode.parentNode
        let curLeft = curDom.offsetLeft
        let curCenter = curDom.offsetWidth / 2
        let parentCenter = parentDom.offsetWidth / 2

        let sub = curLeft - parentCenter + curCenter

        if (sub > 0) {
          this.groupLeft = -sub
        } else {
          this.groupLeft = 0
        }
      }
    },
    mixins: [unit],
  }
</script>

<style scoped>
  .ep-tag {
    height: 100%;
    width: auto;
    position: relative;
    white-space: nowrap;
    overflow: hidden;
    cursor: pointer;
  }

  .ep-tag-border {
    border-bottom: 1px solid #dcdfe6;
  }

  .ep-tag-con {
    height: 100%;
    width: auto;
    position: absolute;
    white-space: nowrap;
    transition: left .3s;
    top: 0;
    left: 0;
  }
</style>


// WEBPACK FOOTER //
// tag.vue?34e74fb1